import _classCallCheck from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { DropdownContext } from './dropdownConstants';
import { KEYHANDLER_DIRECTION } from '../../helpers/constants';
import { preventedEvents } from '../../helpers/util';
import { Tooltip } from '../Tooltip';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
export var InternalDropdownItem = /*#__PURE__*/function (_React$Component) {
  _inherits(InternalDropdownItem, _React$Component);

  var _super = _createSuper(InternalDropdownItem);

  function InternalDropdownItem() {
    var _this;

    _classCallCheck(this, InternalDropdownItem);

    _this = _super.apply(this, arguments);
    _this.ref = React.createRef();
    _this.additionalRef = React.createRef();

    _this.getInnerNode = function (node) {
      return node && node.childNodes && node.childNodes.length ? node.childNodes[0] : node;
    };

    _this.onKeyDown = function (event) {
      // Detected key press on this item, notify the menu parent so that the appropriate item can be focused
      var innerIndex = event.target === _this.ref.current ? 0 : 1;

      if (!_this.props.customChild) {
        event.preventDefault();
      }

      if (event.key === 'ArrowUp') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.UP);

        event.stopPropagation();
      } else if (event.key === 'ArrowDown') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.DOWN);

        event.stopPropagation();
      } else if (event.key === 'ArrowRight') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.RIGHT);

        event.stopPropagation();
      } else if (event.key === 'ArrowLeft') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.LEFT);

        event.stopPropagation();
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.target.click();
        _this.props.enterTriggersArrowDown && _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.DOWN);
      }
    };

    _this.componentRef = function (element) {
      _this.ref.current = element;
      var component = _this.props.component;
      var ref = component.ref;

      if (ref) {
        if (typeof ref === 'function') {
          ref(element);
        } else {
          ref.current = element;
        }
      }
    };

    return _this;
  }

  _createClass(InternalDropdownItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          context = _this$props.context,
          index = _this$props.index,
          isDisabled = _this$props.isDisabled,
          role = _this$props.role,
          customChild = _this$props.customChild,
          autoFocus = _this$props.autoFocus;
      var customRef = customChild ? this.getInnerNode(this.ref.current) : this.ref.current;
      context.sendRef(index, [customRef, customChild ? customRef : this.additionalRef.current], isDisabled, role === 'separator');
      autoFocus && setTimeout(function () {
        return customRef.focus();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          context = _this$props2.context,
          index = _this$props2.index,
          isDisabled = _this$props2.isDisabled,
          role = _this$props2.role,
          customChild = _this$props2.customChild;
      var customRef = customChild ? this.getInnerNode(this.ref.current) : this.ref.current;
      context.sendRef(index, [customRef, customChild ? customRef : this.additionalRef.current], isDisabled, role === 'separator');
    }
  }, {
    key: "extendAdditionalChildRef",
    value: function extendAdditionalChildRef() {
      var additionalChild = this.props.additionalChild;
      return React.cloneElement(additionalChild, {
        ref: this.additionalRef
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          isHovered = _a.isHovered,
          context = _a.context,
          _onClick = _a.onClick,
          component = _a.component,
          role = _a.role,
          isDisabled = _a.isDisabled,
          isAriaDisabled = _a.isAriaDisabled,
          isPlainText = _a.isPlainText,
          index = _a.index,
          href = _a.href,
          tooltip = _a.tooltip,
          tooltipProps = _a.tooltipProps,
          id = _a.id,
          componentID = _a.componentID,
          listItemClassName = _a.listItemClassName,
          additionalChild = _a.additionalChild,
          customChild = _a.customChild,
          enterTriggersArrowDown = _a.enterTriggersArrowDown,
          icon = _a.icon,
          autoFocus = _a.autoFocus,
          styleChildren = _a.styleChildren,
          description = _a.description,
          inoperableEvents = _a.inoperableEvents,
          additionalProps = __rest(_a, ["className", "children", "isHovered", "context", "onClick", "component", "role", "isDisabled", "isAriaDisabled", "isPlainText", "index", "href", "tooltip", "tooltipProps", "id", "componentID", "listItemClassName", "additionalChild", "customChild", "enterTriggersArrowDown", "icon", "autoFocus", "styleChildren", "description", "inoperableEvents"]);
      /* eslint-enable @typescript-eslint/no-unused-vars */


      var classes = css(icon && styles.modifiers.icon, isAriaDisabled && styles.modifiers.ariaDisabled, className);

      if (component === 'a') {
        additionalProps['aria-disabled'] = isDisabled || isAriaDisabled;
      } else if (component === 'button') {
        additionalProps['aria-disabled'] = isDisabled || isAriaDisabled;
        additionalProps.type = additionalProps.type || 'button';
      }

      var renderWithTooltip = function renderWithTooltip(childNode) {
        return tooltip ? React.createElement(Tooltip, Object.assign({
          content: tooltip
        }, tooltipProps), childNode) : childNode;
      };

      var renderClonedComponent = function renderClonedComponent(element) {
        return React.cloneElement(element, Object.assign(Object.assign({}, styleChildren && {
          className: css(element.props.className, classes)
        }), _this2.props.role !== 'separator' && {
          ref: _this2.componentRef
        }));
      };

      var renderDefaultComponent = function renderDefaultComponent(tag) {
        var Component = tag;
        var componentContent = description ? React.createElement(React.Fragment, null, React.createElement("div", {
          className: styles.dropdownMenuItemMain
        }, icon && React.createElement("span", {
          className: css(styles.dropdownMenuItemIcon)
        }, icon), children), React.createElement("div", {
          className: styles.dropdownMenuItemDescription
        }, description)) : React.createElement(React.Fragment, null, icon && React.createElement("span", {
          className: css(styles.dropdownMenuItemIcon)
        }, icon), children);
        return React.createElement(Component, Object.assign({}, additionalProps, isDisabled || isAriaDisabled ? preventedEvents(inoperableEvents) : null, {
          href: href,
          ref: _this2.ref,
          className: classes,
          id: componentID
        }), componentContent);
      };

      return React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            itemClass = _ref.itemClass,
            disabledClass = _ref.disabledClass,
            plainTextClass = _ref.plainTextClass;

        if (_this2.props.role !== 'separator') {
          classes = css(classes, isDisabled && disabledClass, isPlainText && plainTextClass, itemClass, description && styles.modifiers.description);
        }

        if (customChild) {
          return React.cloneElement(customChild, {
            ref: _this2.ref,
            onKeyDown: _this2.onKeyDown
          });
        }

        return React.createElement("li", {
          className: listItemClassName || null,
          role: role,
          onKeyDown: _this2.onKeyDown,
          onClick: function onClick(event) {
            if (!isDisabled && !isAriaDisabled) {
              _onClick(event);

              onSelect(event);
            }
          },
          id: id
        }, renderWithTooltip(React.isValidElement(component) ? renderClonedComponent(component) : renderDefaultComponent(component)), additionalChild && _this2.extendAdditionalChildRef());
      });
    }
  }]);

  return InternalDropdownItem;
}(React.Component);
InternalDropdownItem.displayName = 'InternalDropdownItem';
InternalDropdownItem.defaultProps = {
  className: '',
  isHovered: false,
  component: 'a',
  role: 'none',
  isDisabled: false,
  isPlainText: false,
  tooltipProps: {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick: function onClick(event) {
    return undefined;
  },
  index: -1,
  context: {
    keyHandler: function keyHandler() {},
    sendRef: function sendRef() {}
  },
  enterTriggersArrowDown: false,
  icon: null,
  styleChildren: true,
  description: null,
  inoperableEvents: ['onClick', 'onKeyPress']
};